import { useState } from "react";

export const ServiceFAQ = () => {
  const [open, setOpen] = useState(null);

  const faqs = [
    {
      q: "What services do you provide?",
      a: "We offer web development, mobile app development, UI/UX design, AI/ML integration, and IoT solutions."
    },
    {
      q: "How long does a project take?",
      a: "Project duration depends on complexity. Typically ranges from 2 to 12 weeks."
    },
    {
      q: "Do you provide custom solutions?",
      a: "Yes, every project is fully customized based on your business needs."
    },
    {
      q: "What technologies do you use?",
      a: "We use React, Node.js, MongoDB, Python, AI tools, IoT hardware, and cloud platforms."
    },
    {
      q: "Do you provide mobile apps for both Android and iOS?",
      a: "Yes, we develop cross-platform and native applications."
    },
    {
      q: "Will I get support after project delivery?",
      a: "Yes, we provide maintenance, updates, and technical support."
    },
    {
      q: "Can you help with startup projects?",
      a: "Absolutely. We specialize in building MVPs and scalable startup solutions."
    },
    {
      q: "Do you provide hosting and deployment?",
      a: "Yes, we handle complete deployment including cloud hosting."
    },
    {
      q: "Do you sign NDA for projects?",
      a: "Yes, we ensure complete confidentiality and data protection."
    },
    {
      q: "How much does a project cost?",
      a: "Pricing depends on requirements. We offer affordable and flexible pricing."
    },
    {
      q: "Do you provide UI/UX design separately?",
      a: "Yes, we offer standalone UI/UX design services."
    },
    {
      q: "Can you integrate AI into my application?",
      a: "Yes, we provide AI features like chatbots, predictions, and automation."
    },
    {
      q: "Do you develop IoT-based systems?",
      a: "Yes, we build IoT solutions with real-time monitoring and automation."
    },
    {
      q: "Do you provide training programs?",
      a: "Yes, we offer training in MERN, AI/ML, UI/UX, and more."
    },
    {
      q: "Is internship available?",
      a: "Yes, we provide internship programs with real-time projects."
    },
    {
      q: "Do interns get stipend?",
      a: "Yes, stipend is provided based on performance."
    },
    {
      q: "Will I get job opportunity after internship?",
      a: "High-performing interns may receive job opportunities."
    },
    {
      q: "Can students do part-time internships?",
      a: "Yes, flexible schedules are available for students."
    },
    {
      q: "Do you help with college projects?",
      a: "Yes, we provide full guidance for academic and research projects."
    },
    {
      q: "How can I contact you?",
      a: "You can contact us through our website, email, or phone."
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <h2 className="text-4xl font-bold text-center mb-12">
        Frequently Asked Questions
      </h2>

      <div className="max-w-4xl mx-auto space-y-4">

        {faqs.map((faq, i) => {
          const isOpen = open === i;

          return (
            <div
              key={i}
              className="border rounded-xl bg-white shadow-sm overflow-hidden"
            >
              {/* Question */}
              <div
                onClick={() => setOpen(isOpen ? null : i)}
                className="cursor-pointer px-6 py-4 flex justify-between items-center"
              >
                <h3 className="font-semibold">{faq.q}</h3>
                <span className="text-xl">
                  {isOpen ? "-" : "+"}
                </span>
              </div>

              {/* Answer */}
              <div
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  isOpen ? "max-h-40 py-4" : "max-h-0"
                }`}
              >
                <p className="text-gray-600">{faq.a}</p>
              </div>
            </div>
          );
        })}

      </div>
    </section>
  );
};